// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7000":"623a9b11f180aae3","9723":"e26d4d17c244c97b"}[chunkId] + ".css";
};